import React from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { SlRefresh } from "react-icons/sl";
import SearchComponent from '../../../components/Atoms/Search Input/SearchComponent';





const Pending = ({ data, handleAction, }) => {



    return (
        <>
            <div className=" space-y-4 ">
                <div className='mb-6 flex justify-start'>
                    <SearchComponent placeholder={`Search by name, email, phone or ID...`}/>
                </div>




                {data?.map((ele, index) => (
                    <div key={index} >
                        <div className="flex justify-between items-center mb-4 bg-white p-3 border border-[#D2D2D2] rounded-md">
                            <div className="flex items-center gap-1">
                                <span className="text-[#F6465D] font-medium mr-2">Pending</span>
                                <div className="flex space-x-2">
                                    <button className='cursor-pointer' onClick={handleAction}>
                                        <AiOutlineCloseCircle className="text-[22px] text-[#F6465D]" />
                                    </button>
                                    <button onClick={handleAction}>
                                        <IoMdCheckmarkCircleOutline className="text-[22px] text-[#02BC7D]" />
                                    </button>
                                    <button onClick={handleAction}>
                                        <SlRefresh className="text-[22px] text-[#FFA600] font-bold" />
                                    </button>
                                </div>
                            </div>
                            <div className=" text-[#F6465D]">
                                {`3hr 15 mins ago`}
                            </div>
                        </div>
                        <div className="border border-gray-300 rounded-lg  shadow-sm bg-white">

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ">

                                <div className='space-y-2  md:border-r-2 p-4'>
                                    <img src='/Rectangle 1614423849.png' alt='user' className='w-full h-full max-w-full max-h-[290px]' />
                                    <div className='py-2 space-y-2'>
                                        <div className='flex justify-between place-items-center'>
                                            <p className='text-lg'>{ele?.name}</p><p className='text-[#1D1F2CB2]/70'>{ele?.dob}</p>
                                        </div>
                                        <p className='text-[#1D1F2CB2]/70'>{ele?.email}</p>
                                        <div className='flex justify-between place-items-center'>
                                            <p className='text-[#1D1F2CB2]/70'>{ele?.time}</p><p className='text-[#1D1F2CB2]/70'>{ele?.country}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className=' space-y-2  md:border-r-2 p-4'>
                                    <img src='/Rectangle 1614423845.png' alt='driving license front' />
                                    <img src='/Rectangle 1614423845 (1).png' alt='driving license back' />
                                    <div className='py-2 space-y-2'>
                                        <p className='text-[#1D1F2CB2]/70'>{ele?.idNumber}</p>
                                        <p className='text-[#1D1F2CB2]/70'>{ele?.expiryDate}</p>
                                    </div>

                                </div>
                                <div className='space-y-2   p-4'>
                                    <img src='/image.png' alt='electricity ' />
                                    <div className='py-2 space-y-2'>
                                        <p className='text-[#1D1F2CB2]/70'>{ele?.address}</p>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                ))}
            </div>
        </>
    );
};

export default Pending;